import { render, staticRenderFns } from "./PembelianKategoriAdd.vue?vue&type=template&id=2e28b10f&"
import script from "./PembelianKategoriAdd.vue?vue&type=script&lang=js&"
export * from "./PembelianKategoriAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports